import classNames from 'classnames';
import type { PropsWithChildren, ReactNode } from 'react';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';

const Wrapper = styled(Vertical)`
  position: relative;
  flex: 1;
  min-height: 0;
`;

const FrontWrapper = styled(Vertical)`
  flex: 1;
  min-height: 0;
  opacity: 1;
  transition: opacity 0.5s cubic-bezier(0.26, 0, 0.29, 0.97);
  .swap & {
    opacity: 0;
    pointer-events: none;
  }
`;
const BackWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 0.5s cubic-bezier(0.26, 0, 0.29, 0.97);
  pointer-events: none;
  opacity: 0;
  overflow: hidden;
  .swap & {
    opacity: 1;
    pointer-events: auto;
  }
`;

type Props = {
  back: ReactNode;
  swap: boolean;
};

export const AnimatedContentSwap = ({
  children,
  back,
  swap,
}: PropsWithChildren<Props>) => {
  return (
    <Wrapper className={classNames({ swap })}>
      <FrontWrapper>{children}</FrontWrapper>
      <BackWrapper>{back}</BackWrapper>
    </Wrapper>
  );
};
